// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"439":"5579260e","453":"8772224c","501":"df49fc18","793":"242570de","882":"38d822a7"}[chunkId] + ".chunk.js";
};